var map = {
	"./el_cinematic.mp4": 33299,
	"./en_cinematic.mp4": 85469,
	"./it_cinematic.mp4": 60287,
	"./ro_cinematic.mp4": 53581,
	"./uk_cinematic.mp4": 27404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34179;